import { render, staticRenderFns } from "./modal_edit_limit.vue?vue&type=template&id=d07de560&scoped=true"
import script from "./modal_edit_limit.vue?vue&type=script&lang=js"
export * from "./modal_edit_limit.vue?vue&type=script&lang=js"
import style0 from "./modal_edit_limit.vue?vue&type=style&index=0&id=d07de560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07de560",
  null
  
)

export default component.exports